export type Subscriber<State> = (s: State) => void;

export type UnsubscribeCallback = () => void;

export class Store<State> {
  private readonly listeners = new Set<Subscriber<State>>();

  protected state: State;
  protected initialState: State;

  constructor(initialState: State) {
    this.state = initialState;
    this.initialState = initialState;
  }

  public resetState = (): void => {
    this.setState(this.initialState);
  };

  public getState = (): State => {
    return this.state;
  };

  public setState = (state: State): State => {
    this.state = state;

    this.listeners.forEach((listener) => {
      listener(this.state);
    });

    return this.state;
  };

  public subscribe = (listener: Subscriber<State>): UnsubscribeCallback => {
    this.listeners.add(listener);

    return () => {
      this.listeners.delete(listener);
    };
  };
}
